import { useState } from 'react';

import * as Popover from '@radix-ui/react-popover';
import { Paperclip } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

interface ChildFile {
  id: string;
  name: string;
  doc?: {
    id: string;
    fileId: string;
    caseId: string;
  };
}

interface ChildDocumentsPopoverProps {
  children: React.ReactNode;
  childFiles: ChildFile[];
}

const ChildDocumentsPopover = ({ children, childFiles }: ChildDocumentsPopoverProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigateToChild = (childDocId: string) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('docId', childDocId);
    navigate(location.pathname + '?' + searchParams.toString());
  };

  return (
    <Popover.Root open={isOpen} onOpenChange={setIsOpen}>
      <Popover.Trigger asChild>{children}</Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          className="animate-in fade-in-0 zoom-in-95 z-50 w-80 rounded-lg border bg-white p-4 shadow-lg"
          sideOffset={8}
          align="start"
        >
          <div className="mb-3 flex items-center gap-2">
            <Paperclip size={14} className="text-green-600" />
            <h3 className="text-sm font-semibold">Attachments</h3>
          </div>

          <div className="max-h-48 space-y-1 overflow-y-auto">
            {childFiles.map((childFile) => (
              <button
                key={childFile.doc?.id}
                onClick={() => childFile.doc?.id && handleNavigateToChild(childFile.doc.id)}
                className="block w-full truncate text-left text-sm text-blue-600 underline hover:text-blue-700"
              >
                {childFile.name}
              </button>
            ))}

            {childFiles.length === 0 && (
              <div className="py-4 text-center text-sm text-gray-500">No attachments found</div>
            )}
          </div>

          <Popover.Arrow className="fill-white" />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

export default ChildDocumentsPopover;
